import { render, staticRenderFns } from "./checkDialog.vue?vue&type=template&id=327b38c8&scoped=true&"
import script from "./checkDialog.vue?vue&type=script&lang=js&"
export * from "./checkDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327b38c8",
  null
  
)

export default component.exports